<template>
   <div id="agency-extra-commission-container" @click="dropdown = true" v-click-outside="handlerOutClick">
      <!-- Z-index trick -->
      <div id="aec-dropdown-box" v-if="dropdown">
         <div class="aec-dropdown-box-wrapper">
            <h6>{{ $t("AgencyExtraCommission_title") }}</h6>
            <div class="aec-input-container">
               <input type="number" min="0" step="1" max="999" v-model="commission" @input="handlerInputChange($event)" />
               <div class="aec-action-container">
                  <button @click="handlerIncrease">
                     <i class="gts-icon icon-arrow-up icon-sm gts-animation"></i>
                  </button>

                  <button @click="handlerDecrease">
                     <i class="gts-icon icon-arrow-down icon-sm gts-animation"></i>
                  </button>
               </div>
            </div>
            <div class="aec-checkbox-container">
               <UICheckBox :value="keepCommission" @input="handlerKeepCommissionChange" :label="$t('AgencyExtraCommission_keepSession')" />
            </div>
         </div>
      </div>
      <div id="aec-dropdown">
         <section class="extra-commission-wrapper">
            <span class="extra-commission-alert" v-if="commission > 0"></span>
            <UITooltip tooltip-title="Extra Commission" tooltip-icon="gts-icon icon-extra-commission icon-navbar gts-animation" tooltip-position="bottom"></UITooltip>
         </section>
      </div>
   </div>
</template>

<script>
import UITooltip from "@/components/utils/GtsToolTips.vue";
import UICheckBox from "@/components/unitary/form2/UICheckBox.vue";
export default {
   name: "AgencyExtraCommission",
   components: {
      UITooltip,
      UICheckBox,
   },
   data() {
      return {
         dropdown: false,
         commission: 0,
         keepCommission: false,
      };
   },

   methods: {
      handlerOutClick() {
         const self = this;
         self.dropdown = false;
      },
      handlerUpdateAgencyCommissionExtra() {
         let product;
         switch (this.$route.name) {
            case "FlightSale":
               product = "flight";
               break;
            case "RentACarSale":
               product = "rentacar";
               break;
            default:
               product = undefined;
         }
         if (!isNaN(parseInt(this.commission))) {
            this.$store.commit(`${product}/updateAgencyCommissionExtra`, this.commission);
         } else {
            this.$store.commit(`${product}/updateAgencyCommissionExtra`, 0);
         }
      },
      handlerIncrease() {
         const self = this;
         self.commission < 99 ? self.commission++ : false;
         this.handlerUpdateAgencyCommissionExtra();
      },
      handlerDecrease() {
         const self = this;
         self.commission > 0 ? self.commission-- : false;
         this.handlerUpdateAgencyCommissionExtra();
      },
      handlerInputChange(ev) {
         const self = this;
         self.commission = ev.target.value;
         this.handlerUpdateAgencyCommissionExtra();
      },
      handlerKeepCommissionChange(value) {
         this.keepCommission = value;
         // sessionStorage'a kaydet
         sessionStorage.setItem("keepAgencyCommission", value);

         // Eğer checkbox kaldırıldıysa hemen sıfırla
         if (!value) {
            this.commission = 0;
            this.handlerUpdateAgencyCommissionExtra();
            sessionStorage.removeItem("keepAgencyCommission");
         }
      },
      resetCommissionIfNeeded() {
         if (!this.keepCommission) {
            this.commission = 0;
            this.handlerUpdateAgencyCommissionExtra();
         }
      },
   },
   mounted() {
      // sessionStorage'dan keepCommission durumunu oku
      const keepCommission = sessionStorage.getItem("keepAgencyCommission") === "true";
      this.keepCommission = keepCommission;

      if (keepCommission) {
         // Checkbox işaretliyse store'dan değeri al ve UI'a yansıt
         let product;
         switch (this.$route.name) {
            case "FlightSale":
               product = "flight";
               break;
            case "RentACarSale":
               product = "rentacar";
               break;
            default:
               product = undefined;
         }
         if (product) {
            const storeValue = this.$store.state[product].search.request.agencyCommissionExtra;
            this.commission = storeValue || 0;
         }
      } else {
         // Checkbox işaretli değilse her şeyi sıfırla
         this.commission = 0;
         this.handlerUpdateAgencyCommissionExtra();
      }

      // Search atıldığında komisyonu sıfırla (keepCommission false ise)
      this.$root.$on("search-triggered", this.resetCommissionIfNeeded);
   },
   beforeDestroy() {
      this.$root.$off("search-triggered", this.resetCommissionIfNeeded);
   },
   watch: {
      commission: {
         handler: function (newValue, oldValue) {
            const self = this;
            const newNumber = parseInt(newValue);
            const oldNumber = parseInt(oldValue);
            self.commission = parseInt(newValue);
            if (isNaN(newNumber)) {
               self.commission = 0;
            }
            if (newNumber > 999) {
               self.commission = oldNumber;
            }
         },
      },
   },
};
</script>

<style lang="scss" scoped>
#agency-extra-commission-container {
   position: relative;
   margin: 0 0.75rem;
   height: 100%;
   display: flex;
   align-items: center;
   cursor: pointer;

   #aec-dropdown {
      .extra-commission-wrapper {
         position: relative;
         z-index: 0;

         .extra-commission-alert {
            position: absolute;
            top: 4px;
            right: -12px;
            width: 24px;
            height: 24px;
            //background-color: var(--gray-50);
            background-color: var(--gray-0);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            text-align: center;
            font-weight: 500;
            //color: var(--gray-50);
            color: var(--gray-0);
            font-size: 0.75rem;
            z-index: 101;

            @keyframes extraCommissionAlert {
               from {
                  transform: scale(0.5);
                  opacity: 0;
               }
               to {
                  transform: scale(1);
                  opacity: 1;
               }
            }

            &:before {
               animation-name: extraCommissionAlert;
               animation-timing-function: ease-out;
               animation-duration: 0.75s;
               animation-iteration-count: infinite;
               content: "";
               position: absolute;
               width: 22px;
               height: 22px;
               background-color: none;
               border: 0.1rem solid var(--red-500);
               border-radius: 50%;
            }

            &:after {
               content: "";
               width: 12px;
               height: 12px;
               position: absolute;
               background-color: var(--accent-primary);
               background-color: var(--red-500);
               border-radius: 50%;
            }
         }
      }
   }
   #aec-dropdown-box {
      animation-name: dropdown;
      animation-timing-function: ease-in-out;
      animation-duration: 0.15s;
      position: absolute;
      right: 0;
      margin: auto;
      border-radius: 8px;
      background-clip: padding-box;
      background-color: var(--container-bg);
      top: 100%;
      /* box-shadow: var(--box-shadow-50); */
      box-shadow: var(--gts-box-shadow);
      min-width: 250px;
      padding: 1.5rem;

      @media (max-width: 767.98px) {
         left: 0;
      }

      .aec-dropdown-box-wrapper {
         h6 {
            font-weight: 500;
            font-size: var(--large);
         }
         .aec-input-container {
            margin-top: 1rem;
            display: flex;
            align-items: center;

            input {
               width: 100%;
               border: none;
               outline: none;
               font-size: var(--xxxlarge);
               font-weight: 600;
               color: var(--gray-700);
               border: 2px solid var(--gts-input-border);
               border-radius: 0.5rem;
               text-align: left;
               text-indent: 0.5rem;
               margin-right: 0.5rem;
               background-color: var(--gts-input-background);

               &::-webkit-outer-spin-button,
               &::-webkit-inner-spin-button {
                  -webkit-appearance: none;
                  margin: 0;
               }

               &[type="number"] {
                  -moz-appearance: textfield;
               }
            }

            .aec-action-container {
               display: flex;
               flex-direction: column;
               button {
                  background: transparent;

                  @media (min-width: 768px) and (max-width: 991.98px) {
                     transform: scale(1.5);
                     &:first-child {
                        margin-bottom: 0.75rem;
                     }
                  }
               }
            }
         }

         .aec-checkbox-container {
            margin-top: 1rem;
         }
      }
      &:before {
         content: "";
         position: absolute;
         top: -6px;
         right: 0.5rem;
         margin: auto;
         width: 0;
         height: 0;
         transform: translateX(-50%);
         border-right: 6px solid transparent;
         border-bottom: 6px solid var(--gray-50);
         border-left: 6px solid transparent;

         @media (max-width: 767.98px) {
            left: 0.5rem;
            right: auto;
         }
      }
   }
}
</style>
